import SimpleSelect from '@components/V3/forms/SimpleSelect'
import dayjs from 'dayjs'
import range from 'lodash/range'
import {useEffect} from 'react'

import {ReservationLabel} from '../../Label'
import {useCreateReservationContext} from '../../ReservationContext'

export default function SelectHours() {
  const {storeOptions, dateDay, dateHour, setDateHour} = useCreateReservationContext()

  const options = range(24 * 2)
    .map(index =>
      dayjs()
        .startOf('day')
        .add(index * 30, 'minutes')
        .tz(storeOptions.timezone),
    )
    .filter(date => {
      if (dayjs(dateDay).isSame(dayjs(), 'day')) {
        return date.isAfter(
          dayjs()
            .add(storeOptions.reservationsCloseBeforeMinutes, 'minutes')
            .tz(storeOptions.timezone),
        )
      }
      return true
    })
    .map(day => ({
      label: day.format('HH:mm'),
      value: day.format('HH:mm'),
    }))

  useEffect(() => {
    if (!options.find(option => option.value === dateHour)) {
      if (options[0]) {
        setDateHour(options[0].value)
      }
    }
  }, [dateHour])

  return (
    <div>
      <ReservationLabel>Selecciona la hora</ReservationLabel>
      <SimpleSelect
        options={options}
        value={dateHour}
        onChange={(dateString: string) => setDateHour(dateString)}
      />
    </div>
  )
}
